<template>
  <div class="form-container adminagency-form-container">
    <h1>行政機関の編集</h1>
    <form>
      <table class="admin-agency-edit-table">
        <tbody>
          <!-- 地域 -->
          <tr>
            <td><label class="required-label">都道府県</label></td>
            <td><label>:</label></td>
            <td>
              <select :disabled="limited" v-model="region_id" class="form-control">
                <option value="" disabled>都道府県を選択してください</option>
                <option 
                  v-for="region in regions" 
                  :key="region.region_id" 
                  :value="region.region_id">
                  {{ region.region_id + ' ' + region.region_nm }}
                </option>
              </select>
            </td>
          </tr>

		  <!-- Added R.K -->
          <tr>
            <td><label class="required-label">行政機関</label></td>
            <td><label>:</label></td>
            <td>
              <select :disabled="limited" v-model="group_id">
                <option value="" disabled>行政機関を選択してください</option>
                <option v-for="group in groups"
				 :key="group.gyouseiId"
				 :value="group.gyouseiId">
                {{ group.gyouseiId + ' ' + group.gyouseiName }}</option>
              </select>
            </td>
          </tr>

          <!-- 行政機関ID -->
          <tr>
            <td><label class="required-label">行政機関ID</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="editAdmin.gyouseiId" class="form-control" disabled/>
              <span v-if="errors.gyouseiId" class="error">{{ errors.gyouseiId }}</span>
            </td>
			<td>
              <button :disabled="limited" class="first" @click="openModal">行政機関検索</button>
			</td>
          </tr>
          <!-- 行政機関名 -->
          <tr>
            <td><label class="required-label">行政機関名</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="editAdmin.gyouseiName" class="form-control" />
              <span v-if="errors.gyouseiName" class="error">{{ errors.gyouseiName }}</span>
            </td>
          </tr>
          <!-- 行政機関ｶﾅ -->
          <tr>
            <td><label>行政機関ｶﾅ</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="editAdmin.kana" class="form-control" />
              <span v-if="errors.kana" class="error">{{ errors.kana }}</span>
            </td>
          </tr>
          <!-- 行政機関住所 -->
          <tr>
            <td><label>行政機関住所</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="editAdmin.gyouseiZyusho" class="form-control" />
              <span v-if="errors.gyouseiZyusho" class="error">{{ errors.gyouseiZyusho }}</span>
            </td>
          </tr>
          <!-- 担当者部署 -->
          <tr>
            <td><label>担当部署</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="editAdmin.managerDepart" class="form-control" />
              <span v-if="errors.managerDepart" class="error">{{ errors.managerDepart }}</span>
            </td>
          </tr>
          <!-- 担当者名 -->
          <tr>
            <td><label>担当者名</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="editAdmin.managerName" class="form-control" />
              <span v-if="errors.managerName" class="error">{{ errors.managerName }}</span>
            </td>
          </tr>
          <!-- 電話番号 -->
          <tr>
            <td><label>電話番号</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="editAdmin.managerTell" class="form-control" />
              <span v-if="errors.managerTell" class="error">{{ errors.managerTell }}</span>
            </td>
          </tr>
          <!-- メール -->
          <tr>
            <td><label>メール</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="editAdmin.managerMail" class="form-control" />
              <span v-if="errors.managerMail" class="error">{{ errors.managerMail }}</span>
            </td>
          </tr>
        </tbody>
      </table>
  </form>
  <div class="button-container">
	<span>
      <button v-if="editAdmin.deleteFlg==0&&!limited" type="button" class="second" @click="dodel" :disabled="btnoff">削除</button>
      <button v-else-if="!limited" type="button" class="second" @click="undel" :disabled="btnoff">復活</button>
      <button type="button" class="alert" @click="updateAdminAgency" :disabled="btnoff">更新</button>
	</span>
  </div>
  <!-- 検索モーダル -->
  <SearchModal
    caller="agency" 
    :isVisible="isModalVisible"
    :displayColumns="[
      { key: 'id', label: '行政機関ID' },
      { key: 'name', label: '行政機関名称' },
      { key: 'kana', label: '行政機関(ｶﾅ) ' }
    ]"
    :title="'行政機関検索'" 
    :categories="[]" 
    :targetData="[]" 
    @close="closeModal"
    @select="handleSelect"
  />

 </div>
</template>

<script>
import "@/assets/styles/AdminAgency.css";
import axios from 'axios'; // axiosをインポート
axios.defaults.timeout = process.env.VUE_TIMEOUT||5000;

import SearchModal from '@/vue/SearchModal.vue';

export default {
  name: 'AdminAgencyEdit',
  components: {
    SearchModal,
  },
  data() {
    return {
	  btnoff: true,
	  limited: false,
      regions: [],
	  region_id: '',
	  groups: [],
	  group_id: '',
      editAdmin: {
        region: '',
        gyouseiId: '',
        gyouseiName: '',
        managerDepart: '',
        managerName: '',
        managerTell: '',
        managerMail: '',
        gyouseiKbn: '国',
        gyouseiZyusho: '',
        agencyIdCount: 0,
        agencyIdStatus: '無効',
        hunterIdCount: 0,
        hunterIdStatus: '無効',
        mieruAdminCount: 0,
        mieruAdminStatus: '無効',
        mieruMemberCount: 0,
        mieruMemberStatus: '無効',
		kana: '',
		deleteFlg: 0,
        modifierId: '',
      },
      errors: {},
      isModalVisible: false,
      searchData: {
        searchTerm: '', 
        category: 'all',
      },
      modalTitle: '行政機関検索',  // モーダルのタイトル
      selectedResult: null,  // 選択された検索結果
    };
  },
  mounted() {
    this.getRegionDetails();
	const section = localStorage.getItem("section");
    this.limited = (section != '0000');
	if (this.limited) {
		this.region_id = localStorage.getItem("regionId");
		//this.group_id = localStorage.getItem("directAdminAgency");
	}
  },
  watch: {
	// 2026/04/01 Added by RFJ R.Komatsu
	region_id: async function() {
	  if (!this.region_id) return;

	  this.editAdmin.region = this.region_id;
      const token = localStorage.getItem("jwtToken");
      const requestData = { regionId: this.region_id };
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/addminAgencyRegister/getRegionList`,
          requestData,
          {
            headers: {           
              Authorization: `Bearer ${token}`, // JWTトークンを送信
            },
          }
        );
        this.groups = response.data.data;
		if (this.limited) {
			this.group_id = localStorage.getItem("directAdminAgency");
		} else {
			this.group_id = '';
		}
      } catch (error) {
        alert("タイムアウトです、ログインしなおしてください");
        this.$router.push({ name: 'Login' });
      }
	  this.btnoff = true;
	},
	group_id: async function() {
	  if (!this.group_id) return;
      this.editAdmin.gyouseiId = this.group_id;
      try {
      	const token = localStorage.getItem("jwtToken");
        const para = { id: this.group_id };
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/addminAgencyRegister/getDetail`,
          para,
          { headers: { Authorization: `Bearer ${token}` } }
        );
		this.handle_after(response.data.data);
      } catch (error) {
		if (error.status==404) {
        	alert("登録されていません");
      		this.resetForm();          
	  		this.btnoff = true;
			return;
		}
        alert("タイムアウトです、ログインしなおしてください");
        this.$router.push({ name: 'Login' });
      }

	},
  },
  methods: {
    isRequired(value) {
       return value !== null && value !== undefined && String(value).trim() !== '';
    },
    isMaxLength(value, maxLength) {
      return value.length <= maxLength;
    },
    isAlphanumeric(value) {
      return /^[a-zA-Z0-9]+$/.test(value);
    },
    isPhoneNumber(value) {
      return /^\d{10,11}$/.test(value);
    },
    isEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) && value.length <= 50;
    },
    isTwoDigitRegionID(value) {
      return /^\d{2}$/.test(value);  // 2桁の数字のみを許可
    },
    validateForm() {
      this.errors = {}; // エラーメッセージを初期化
      const fields = [
        {
          key: 'gyouseiId',
          value: this.editAdmin.gyouseiId,
          label: '行政機関ID',
          isRequired: true,
          maxLength: 5,
          additionalCheck: this.isAlphanumeric,
          errorMessage: '行政機関IDは英数字のみで入力してください',
        },
        {
          key: 'gyouseiName',
          value: this.editAdmin.gyouseiName,
          label: '行政機関名称',
          isRequired: true,
          maxLength: 32
        },
      ];

      fields.forEach(({ key, value, label, isRequired, maxLength, additionalCheck, errorMessage }) => {
        if (isRequired && !this.isRequired(value)) {
          this.errors[key] = `${label}は必須項目です`;
        } else if (maxLength && !this.isMaxLength(value, maxLength)) {
          this.errors[key] = `${label}は${maxLength}文字以内で入力してください`;
        } else if (additionalCheck && !additionalCheck(value)) {
          this.errors[key] = errorMessage;
        }
      });

      return Object.keys(this.errors).length === 0; // エラーがない場合はtrue
    },
    validateAndRegister() {
      if (this.validateForm()) {
        this.register();
      } else {
        // バリデーションエラーがある場合にポップアップで警告を表示
        alert('入力エラーがあります');
      }
    },
    resetForm() {
	  this.btnoff = true;
	  this.region_id = '';
	  this.group_id = '';
      this.editAdmin = {
        region_id: '',
        gyouseiId: '',
        gyouseiName: '',
        gyouseiKbn: '',
        managerDepart: '',
        managerName: '',
        managerTell: '',
        managerMail: '',
        gyouseiKbn: '市区町村',
        gyouseiZyusho: '',
        agencyIdCount: '0',
        agencyIdStatus: '無効',
        hunterIdCount: '0',
        hunterIdStatus: '無効',
        mieruAdminCount: '0',
        mieruAdminStatus: '無効',
        mieruMemberCount: '0',
        mieruMemberStatus: '無効',
        modifierId: '',
		kana: '',
		deleteFlg: 0
      };
    },
    openModal() {
      this.searchData = { keyword: '' }
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    handleSelect(result) {
      if (result && result.target) {
        return;
      }
	  //this.editAdmin.region = result.region;
	  this.region_id = result.region;
	  this.group_id = result.id;
	},
    handle_after(result) {
      // 他のフィールドを更新
      this.editAdmin = {
        ...this.editAdmin,
        region: result.region_id,
        gyouseiId: result.gyouseiId,
        gyouseiName: result.gyouseiName || '',
        gyouseiKbn: result.gyouseiKbn === '0' ? '国' : 
                    result.gyouseiKbn === '1' ? '都道府県' : 
                    result.gyouseiKbn === '2' ? '市区町村' : null,
        managerDepart: result.managerDepart || '',
        managerName: result.managerName || '',
        managerTell: result.managerTell || '',
        managerMail: result.managerMail || '',
        gyouseiZyusho: result.gyouseiZyusho || '',
        agencyIdCount: result.agencyIdCount || '',
        agencyIdStatus: result.agencyIdStatus === '1' ? '有効' : '無効',
        hunterIdCount: result.hunterIdCount || '',
        hunterIdStatus: result.hunterIdStatus === '1' ? '有効' : '無効',
        mieruAdminCount: result.mieruAdminCount || '',
        mieruAdminStatus: result.mieruAdminStatus === '1' ? '有効' : '無効',
        mieruMemberCount: result.mieruMemberCount || '',
        mieruMemberStatus: result.mieruMemberStatus === '1' ? '有効' : '無効',
        modifierId: '',
		kana: result.kana,
		deleteFlg: result.deleteFlg
      };
	  this.btnoff = false;
    },
    async getRegionDetails() {
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId");

      try {
        // リクエストボディに id を含める
        const requestData = { id: userId };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/regionSearch/getList`,
          requestData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          this.regions = response.data.data;
        } else {
        	alert("不明なエラーです");
        }
      } catch (error) {
        alert("タイムアウトです、ログインしなおしてください");
        this.$router.push({ name: 'Login' });
      }
    },
	dodel() {
		this.editAdmin.deleteFlg = 1;
		this.updateAdminAgency();
	},
	undel() {
		this.editAdmin.deleteFlg = 0;
		this.updateAdminAgency();
	},
    async updateAdminAgency() {
      // JWTトークンを取得
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId");

      try {
        // サーバーに送信するデータ
        const requestData = {
          region_id: this.editAdmin.region,
          gyouseiId: this.editAdmin.gyouseiId,
          gyouseiName: this.editAdmin.gyouseiName,
          managerDepart: this.editAdmin.managerDepart,
          managerName: this.editAdmin.managerName,
          managerTell: this.editAdmin.managerTell,
          managerMail: this.editAdmin.managerMail,
          gyouseiKbn: this.editAdmin.gyouseiKbn === '国' ? 0 : 
                      this.editAdmin.gyouseiKbn === '都道府県' ? 1 : 
                      this.editAdmin.gyouseiKbn === '市区町村' ? 2 : null,
          gyouseiZyusho: this.editAdmin.gyouseiZyusho,
          agencyIdCount: this.editAdmin.agencyIdCount,
          agencyIdStatus: this.editAdmin.agencyIdStatus === '有効' ? 1 : 0,
          hunterIdCount: this.editAdmin.hunterIdCount,
          hunterIdStatus: this.editAdmin.hunterIdStatus === '有効' ? 1 : 0,
          mieruAdminCount: this.editAdmin.mieruAdminCount,
          mieruAdminStatus: this.editAdmin.mieruAdminStatus === '有効' ? 1 : 0,
          mieruMemberCount: this.editAdmin.mieruMemberCount,
          mieruMemberStatus: this.editAdmin.mieruMemberStatus === '有効' ? 1 : 0,
          modifierId: userId,
          kana: this.editAdmin.kana,
		  deleteFlg: this.editAdmin.deleteFlg
        };

        // APIリクエスト送信
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/addminAgencyRegister/update`,
          requestData,
          {
            headers: {           
              Authorization: `Bearer ${token}`, // JWTトークンを送信
            },
          }
        );

        // ステータスコード200の場合（送信成功）
        if (response.status === 200) {
		  if (this.editAdmin.deleteFlg=="1")
        	alert("データが削除されました");
		  else
        	alert("データが更新されました");
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
        } else {
        	alert("不明なエラーです");
		}
      } catch (error) {
        alert("タイムアウトです、ログインしなおしてください");
        this.$router.push({ name: 'Login' });
      }
      if (!this.limited)
      	this.resetForm();          
    },
  },
};
</script>

<style scoped>
.usual { background-color: #17a2b8; }
.first { background-color: #28a745; }
.alert { background-color: #ff6347; }
.second { background-color: #6c757d; }
</style>
